import { Injectable } from '@angular/core';

import { BehaviorSubject } from 'rxjs';

@Injectable()
export class ReportLoadingService {
  isLoading = new BehaviorSubject<any>(false);

  constructor() { }
 
  // method này để change source message 
  setData(isLoading) {
    this.isLoading.next(isLoading);
  }
  getData()
  {
      return this.isLoading.asObservable();;
  }
}


// WEBPACK FOOTER //
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/_services/report-loading.service.ts